import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import Icon from '../../Icon';
import { usePrevious } from '../../utils';

const KpiContainer = styled.div`
  text-align: center;
  flex: 1;
  svg {
    margin-top: 15px;
    color: #ff513c;
    font-size: 14px;
  }
`

const Number = styled.div`
  color: #555555;
  line-height: 35px;
  font-size: 35px;
  @media (max-width: 1000px) {
    line-height: 2.5vw;
    font-size: 2.5vw;
  }
  font-weight: 300;
`

const KpiTitle = styled.div`
  color: #888888;
  text-transform: uppercase;
  font-size: 12px;
  @media (max-width: 1000px) {
    font-size: 1.2vw;
  }
  margin-bottom: 15px;
  margin-top: 3px;
`

function delay(duration) {
  return new Promise((resolve) => {
    setTimeout(resolve, duration);
  });
}

const FadeNumber = ({value}) => {
  const [display, setDisplay] = useState(value);
  const previousValue = usePrevious(display);
  const transitionTiming = 500;
  const styleIdle = {
    opacity: 1,
    transition: `${transitionTiming}ms all ease-in-out`
  };
  const styleFadeout = {
    ...styleIdle,
    opacity: 0
  };
  const styleFadein = {
    ...styleIdle,
    opacity: 1
  };
  const [transition, setTransition] = useState(styleIdle);

  useEffect(() => {
    Promise.resolve()
      .then(() => {
        setTransition(styleFadeout);
        setDisplay(previousValue);
      })
      .then(() => delay(transitionTiming))
      .then(() => {
        setTransition(styleFadein);
        setDisplay(value);
      })
      .then(() => delay(transitionTiming))
      .then(() => setTransition(styleIdle));
    setDisplay(value);
  }, [value]);

  return (
    <Number style={transition}>{display}</Number>
  )
}

export default function Kpi ({icon, value, title}) {
  return (
    <KpiContainer>
      <Icon icon={icon}/><br/>
      <FadeNumber value={value}/>
      <KpiTitle>{title}</KpiTitle>
    </KpiContainer>
  )
}
